import React, { useMemo } from 'react';
import { BULK_TYPES } from '../../pages/orders/constants';
import FormWrapper from '../FormWrapper';

function BulkSelector({ props }) {
  const { t, isNew, select } = props;

  const enableIssuingOrders = useMemo(
    () => window._env_.ENABLE_ISSUING_ORDERS === 'true',
    [],
  );

  const bulkTypes = useMemo(
    () =>
      enableIssuingOrders
        ? Object.keys(BULK_TYPES)
        : Object.keys(BULK_TYPES).filter(
            (type) => BULK_TYPES.ISSUING_CARDS !== type,
          ),
    [enableIssuingOrders],
  );

  return (
    <FormWrapper.Select
      label={t('entity.orders.bulkTypes')}
      props={{
        disabled: !isNew,
        options: bulkTypes
          .filter((bt) => BULK_TYPES.ISSUING_NON_NOMINAL_CARDS !== bt)
          .map((o) => ({
            id: o,
          })),
        allowClear: false,
        labelProp: (obj) => t(`entity.orders.bulkType.${obj.id}`),
        ...select('bulkType'),
      }}
    />
  );
}

export default BulkSelector;
